import styled from '@emotion/styled';

export const ELabel = styled.label`
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-thin);
  color: var(--color-core-primary);
  margin-bottom: var(--gutter-tiny);
`;

export const ELabelSubtext = styled.p`
  display: flex;
  align-items: center;
  color: var(--color-core-dark-grey);
  font-size: var(--font-size-small);
  font-weight: var(--label-subtext-font-weight);
  margin-bottom: var(--gutter-tiny);
`;
